<script>

import MainComplaintForm from "./MainComplaintForm.svelte";
import { Circle3 } from "svelte-loading-spinners";

export let currentRoute;
let type = 'free_assistance'

let company_domain = currentRoute.namedParams.company
let showForm = false

const fetchData = async () => {

  const request = await fetch(`${__myapp.env.API_URL}client/${company_domain}`);
  const json = await request.json();

  showForm = true

  return {
    uuid: json.data.client.uuid,
    company: json.data.client.company,
  }

};

const request = fetchData();

</script>

<style>
  .themed {
    --borderRadius: 0px;
    --height: 50px;
    --border: 1px solid #dae1e3;
    --inputFontSize: 16px;
    --borderFocusColor: #80bdff;
    --placeholderColor: #a9a9a9;
    --listBorderRadius: 0px;
  }
</style>

<section id="denuncia" class="section mx-5">
  <div class="container">

    {#await request}
      <div class="d-flex justify-content-center">
        <Circle3
          size="60"
          ballTopLeft="#4843d2"
          ballTopRight="#4843d2"
          ballBottomLeft="#4843d2"
          ballBottomRight="#4843d2"
          unit="px" />
      </div>
    {:then result}

      {#if showForm}
        <MainComplaintForm client={result} {type} />
      {/if}

    {:catch error}
      <div class="alert alert-danger" style="border-radius:0px" role="alert">
        No hemos podido obtener la información, contacta al administrador
      </div>
      <h1>Error</h1>
    {/await}



  </div>
</section>